class BerriMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.onTabActivate = this.onTabActivate.bind(this);
    this.onTabKeydown = this.onTabKeydown.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', this.onTabActivate);
      tab.addEventListener('focus', this.onTabActivate);
      tab.addEventListener('keydown', this.onTabKeydown);
    });
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('mouseenter', this.onTabActivate);
      tab.removeEventListener('focus', this.onTabActivate);
      tab.removeEventListener('keydown', this.onTabKeydown);
    });
  }

  onTabKeydown(event) {
    // Space activates the panel without navigating (Enter follows the link).
    if (event.key !== ' ') return;
    event.preventDefault();
    this.onTabActivate(event);
  }

  onTabActivate(event) {
    const tab = event.currentTarget;
    const panelId = tab.getAttribute('aria-controls');
    if (!panelId) return;

    this.tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);

      if (isActive) {
        const sliderComponent = panel.querySelector('slider-component');
        if (sliderComponent?.resetPages) {
          requestAnimationFrame(() => sliderComponent.resetPages());
        }
      }
    });
  }
}

customElements.define('berri-mega-menu', BerriMegaMenu);
